<script>
import axios from 'axios';
import $ from 'jquery';
import M from 'materialize-css';

import Message from './Message.vue'
import ModalDialog from './ModalDialog.vue'
import parser from '../funccall.js'

import {WebSocketConnectionManager, ClientConnections} from '../api.js'

const CHANNEL_PROTOCOLS = {
	"v1.jrpc.zebra.com": [
		"JSON-RPC",
	],
	"v1.config.zebra.com": [
		"ZEBRA-JSON",
	],
	"v1.main.zebra.com": [
		"WEBLINK-V1-MAIN",
	],
	"v1.card.main.zebra.com": [
		"ZEBRA-JSON",
		"WEBLINK-V1-MAIN",
	],
	"v1.push.zpc.zebra.com": [
		"AVS",
	],
	"v1.main.mqtt.west": [
		"MQTT-JSON",
	],
	"v1.jsonrpc.mqtt.west": [
		"JSON-RPC",
	]
}

// TODO: get these from the API?
const CHANNEL_TYPES = {
	"v1.weblink.zebra.com": [
		"v1.config.zebra.com",
		"v1.echo.zebra.com",
		"v1.raw.zebra.com",
	],
	"v1.card.weblink.zebra.com": [
		"v1.config.zebra.com",
		"v1.echo.zebra.com",
	],
};

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function createJsonRpc() {
	return JSON.stringify({
		jsonrpc: "2.0",
		method: "",
		id: guid(),
		params: [],
	}, null, 2)
}

function toUTF8Array(str) {
	let utf8 = [];
	for (var i=0; i < str.length; i++) {
		let charcode = str.charCodeAt(i);
		if (charcode < 0x80) utf8.push(charcode);
		else if (charcode < 0x800) {
			utf8.push(0xc0 | (charcode >> 6),
				0x80 | (charcode & 0x3f));
		}
		else if (charcode < 0xd800 || charcode >= 0xe000) {
			utf8.push(0xe0 | (charcode >> 12),
				0x80 | ((charcode>>6) & 0x3f),
				0x80 | (charcode & 0x3f));
		}
		// surrogate pair
		else {
			i++;
			charcode = ((charcode&0x3ff)<<10)|(str.charCodeAt(i)&0x3ff)
			utf8.push(0xf0 | (charcode >>18),
				0x80 | ((charcode>>12) & 0x3f),
				0x80 | ((charcode>>6) & 0x3f),
				0x80 | (charcode & 0x3f));
		}
	}
	return new Uint8Array(utf8);
}

function toText(blob, callback) {
	const reader = new FileReader();
	reader.onload = () => {
		callback(reader.result);
	};
	reader.readAsText(blob);
}

function closeIsFatal(code) {
	return code !== 4104 && code >= 4000
}

function dataTransferPath(conn_id) {
	return '/api/v2/data-transfer/' + conn_id + '/websocket'
}

class History {
	constructor() {
		this.maxsize = 100
		this.history = null
		this.idx = 0
		this.localstorage_key = 'conn_cmd_history'

		this.initialize_history()
	}

	initialize_history() {
		let loaded = false
		if (localStorage[this.localstorage_key] !== undefined) {
			try {
				this.history = JSON.parse(localStorage[this.localstorage_key])
				loaded = Array.isArray(this.history)

			} catch (e) {
				loaded = false
			}
		}

		if (!loaded) {
			this.history = []
		}

		this.idx = this.history.length
	}

	save_history = () => {
		localStorage[this.localstorage_key] = JSON.stringify(this.history)
	}

	up = () => {
		if (this.history.length > 0) {
			if (this.idx > 0)
				this.idx--

			return this.history[this.idx]
		} else {
			return ''
		}
	}

	down = () => {
		if (this.idx < this.history.length) {
			this.idx++
		}

		if (this.idx < this.history.length) {
			return this.history[this.idx]
		} else {
			return ''
		}
	}

	push = (item) => {
		let prev = (this.history.length >= 1) ? this.history[this.history.length - 1] : null;

		if (prev !== item) {
			if (this.history.length >= this.maxsize)
				this.history.shift()

			this.history.push(item)
			this.save_history()
		}

		this.idx = this.history.length
	}
}


class InputProcessResult {
	constructor(valid, msg) {
		this.valid = valid
		this.msg = msg
	}
}

class ReceivedMessage {
	constructor(message, format, title, raw, error) {
		this.message = message
		this.title = title
		this.raw = raw
		this.format = format
		this.error = error
		this.time = (new Date()).toISOString().replace('T', ' ').replace('Z', '')
	}
}

class ProtocolHandler {
	constructor(handler) {
		this.handler = handler
	}

	message_processed = (...args) => {
		this.handler.message_processed(new ReceivedMessage(...args))
	}

	send = (msg) => {
		this.handler.send(msg)
	}

	execute_method = () => {
		return new InputProcessResult(false, "Protocol does not support functions")
	}

	process_input = () => {
		throw new Error("Not implemented!")
	}

	message_received = () => {
		throw new Error("Not implemented!")
	}
}

class JsonRpcHandler extends ProtocolHandler {
	constructor(handler) {
		super(handler)
		this.ongoing = new Map()
	}

	message_received = (msg) => {
		const obj = JSON.parse(msg)

		// IS EEET A NOTIFICATION?
		if (obj.id === undefined) {
			const title = 'Notification: ' + obj.method;
			let formatted = ''
			let format = 'raw'

			if (obj.params !== null && obj.params !== undefined) {
				formatted = JSON.stringify(obj.params);
				format = 'json'
			}

			this.message_processed(formatted, format, title, msg)

		} else if (this.ongoing.has(obj.id)) {
			const method = this.ongoing.get(obj.id)
			this.ongoing.delete(obj.id)

			let formatted = ''
			let format = 'raw'
			let prefix = 'Completed'
			let error = false

			if (obj.error !== null && obj.error !== undefined) {
				formatted = JSON.stringify(obj.error);
				format = 'json'
				prefix = this.get_error_type(obj.error.code)
				error = true

			} else if (obj.result !== null && obj.result !== undefined) {
				formatted = JSON.stringify(obj.result);
				format = 'json'
				prefix = 'Result'
			}

			const title = prefix + ': ' + method
			this.message_processed(formatted, format, title, msg, error)

		} else {
			this.message_processed(msg, 'json')
		}
	}

	get_error_type(code) {
		if (code === -32700)
			return 'Parse Error'
		else if (code === -32600)
			return 'Invalid Request'
		else if (code === -32601)
			return 'Method Not Found'
		else if (code === -32602)
			return 'Invalid Parameters'
		else
			return 'Error'
	}

	execute_method = (method_call) => {
		const jsonrpc_call = {
			id: guid(),
			jsonrpc: '2.0',
		}

		jsonrpc_call.method = method_call.method
		if (method_call.params !== null)
			jsonrpc_call.params = method_call.params

		this.ongoing.set(jsonrpc_call.id, jsonrpc_call.method)
		const message = JSON.stringify(jsonrpc_call)
		this.send(message)

		return new InputProcessResult(true)
	}

	process_input = (input_str) => {
		try {
			const rpc_call = JSON.parse(input_str)

			if (rpc_call.method && rpc_call.id) {
				this.ongoing.set(rpc_call.id, rpc_call.method)
			}
		} catch (e) {
			console.log("Sending invalid JSON :o!")
		}

		this.handler.send(input_str)
		return new InputProcessResult(true)
	}
}

class RawBinaryHandler extends ProtocolHandler {
	message_received = (msg) => {
		toText(msg, (converted) => {
			this.message_processed(converted, 'raw')
		});
	}

	process_input = (input_str) => {
		const message = toUTF8Array(input_str)
		this.send(message)
		return new InputProcessResult(true)
	}
}

class JsonBinaryHandler extends RawBinaryHandler {
	message_received = (msg) => {
		toText(msg, (converted) => {
			this.message_processed(converted, 'json')
		});
	}
}

class JsonTextHandler extends RawBinaryHandler {
	message_received = (msg) => {
		this.message_processed(msg, 'json')
	}
}


class MessageHandler {
	constructor(message_processed) {
		this.send = null
		this.channel = null
		this.message_processed = message_processed
		this.handler = null
	}

	set_handler = () => {
		let handler_type;

		if (this.supportsProtocol('JSON-RPC')) {
			handler_type = JsonRpcHandler

		} else if (this.supportsProtocol('ZEBRA-JSON')) {
			handler_type = JsonBinaryHandler

		} else if (this.supportsProtocol('WEBLINK-V1-MAIN')) {
			handler_type = JsonBinaryHandler

		} else if (this.supportsProtocol('AVS')) {
			handler_type = JsonBinaryHandler

		} else if (this.supportsProtocol("MQTT-JSON")) {
			handler_type = JsonTextHandler

		} else {
			handler_type = RawBinaryHandler
		}

		this.handler = new handler_type(this);
	}

	handle_websocket_message = (evt) => {
		if (this.handler !== null) {
			this.handler.message_received(evt.data)
		} else {
			console.log("Received message with no handler!")
			const processed = new ReceivedMessage(evt.data, 'raw')
			this.message_processed(processed)
		}
	}

	supportsProtocol = (proto) => {
		if (this.channel !== null && this.channel in CHANNEL_PROTOCOLS) {
			return CHANNEL_PROTOCOLS[this.channel].includes(proto)
		} else {
			return false;
		}
	}

	connected = (ws, channel) => {
		this.send = ws.send.bind(ws)
		this.channel = channel
		this.set_handler()
		ws.onmessage = this.handle_websocket_message

		const msg = new ReceivedMessage("Reading from channel: " + this.channel, 'raw')
		this.message_processed(msg)
	}

	process_input = (input_str) => {
		if (this.handler === null) {
			return new InputProcessResult(false, 'Not connected!');

		// it looks like a function call...
		} else if (input_str.match(/[a-z][a-z_.0-9]+\(/i)) {
			try {
				const result = parser.parse(input_str)
				return this.handler.execute_method(result)

			} catch (e) {
				return new InputProcessResult(false, e.message)
			}
		} else {
			return this.handler.process_input(input_str)
		}
	}

	disconnected = () => {
		this.send = null
		this.channel = null
		this.handler = null
	}
}


export default {
	components: {
		Message,
		'modal-dialog': ModalDialog,
	},
	computed: {
		mainConnectionUrl() {
			return `/api/server/${this.server_id}/client/${this.client_id}`;
		},
		streamFileData: function () {
			return this.messages.reduce(function (accumulator, current) {
				return accumulator + `[${current.time}] : ${current.message}\r\n`;
			}, "");
		},
		streamFileName: function () {
			return `west-client${this.client_id}-${Date.now()}.log`;
		},
		channelTypes() {
			if (this.channels.length !== 0 && this.channels[0].subprotocol in CHANNEL_TYPES) {
				return CHANNEL_TYPES[this.channels[0].subprotocol]
			} else {
				return null
			}
		}
	},
	data: function () {
		const connManager = new WebSocketConnectionManager()

		connManager.onConnect((ws) => {
			this.connection_error = ""
			for (let conn of this.channels) {
				if (conn.id === this.selectedConnection) {
					this.connection = conn
					break
				}
			}

			if (this.connection) {
				console.log("Connected to", this.connection.name)
				this.handler.connected(ws, this.connection.name)

				this.$nextTick(() => {
					if (this.$refs['json-rpc-dropdown']) {
						M.Dropdown.init(this.$refs['json-rpc-dropdown'])
					}
				});

			}
		});

		connManager.onDisconnect((code, reason) => {
			console.log("Disconnected. code:", code, "reason", reason)

			if (code !== 1000 && this.selectedConnection !== null)
				this.connection_error = reason

			this.connection = null
			this.handler.disconnected()

			// 4107 means it was closed via API request. Disable autoreconnect so
			// something else can connect.
			if (code === 4107) {
				this.saveAutoconnect = false
				this.autoconnect = false
			}

			return !closeIsFatal(code)
		});

		return {
			openChannelType: "",
			// connection mirrors the websocket state; selectedConnection is our preference
			connection: null,
			connection_error: "",
			selectedConnection: null,
			channels: [],
			message: "",
			messages: [],
			messageTimeout: 10,
			mpfFileName: "",
			openedUuid: null,
			socket: null,
			autoconnect: true,
			saveAutoconnect: true,
			connManager: connManager,
			history: new History(),
			handler: new MessageHandler(this.messageReceived),
			input_error: "",
		};
	},
	watch: {
		autoconnect(value) {
			if (this.saveAutoconnect) {
				localStorage.autoconnect = value.toString()
			} else {
				this.saveAutoconnect = true
			}

			if (value) {
				this.setChannel(null, this.channels, value)
			} else {
				this.selectedConnection = null
			}
		},
		selectedConnection(new_conn) {
			this.connection_error = ""

			if (new_conn !== null)
				this.connManager.connect(dataTransferPath(new_conn))
			else
				this.connManager.connect(null)
		},
		message: function() {
			this.$nextTick(() => {
				if (this.$refs.new_message) {
					M.textareaAutoResize(this.$refs.new_message)
					this.$refs.new_message.focus();
				}
			})
		},
		channels(new_channels) {
			if (this.openedUuid) {
				this.setChannel(this.openedUuid, new_channels)
				this.openedUuid = null;

			} else {
				if (this.selectedConnection)
					this.setChannel(this.selectedConnection, new_channels, this.autoconnect)
				else
					this.setChannel(null, new_channels, this.autoconnect)
			}
		},
	},
	name: "Connection",
	methods: {
		supportsProtocol: function(proto) {
			return this.handler.supportsProtocol(proto)
		},
		clearMessages: function () {
			this.messages = [];
		},
		closeChannel: function (channel) {
			this.api.jsonrpc.call('api.v2.connections.close_connection', {'connection_id': channel.id});
		},
		populateJsonRpcMethod: function(str) {
			this.message = str
		},
		populateJsonRpc: function() {
			this.message = createJsonRpc()
		},
		encodeToMpf: function () {
			let $mpfNameInput = $('#mpf-name');
			if (this.mpfFileName.length === 0) {
				$mpfNameInput.removeClass('valid');
				$mpfNameInput.addClass('invalid');
			}
			else {
				$mpfNameInput.removeClass('invalid');
				$mpfNameInput.addClass('valid');

				let delimeter = guid();
				this.message = `{}--${delimeter}\r\n` +
					`Content-Disposition: filename="${this.mpfFileName}"\r\n` +
					'Content-Type: application/octet-stream\r\n' +
					'Content-Transfer-Encoding: binary\r\n' +
					`\r\n${this.message}\r\n` +
					`--${delimeter}--\r\n\r\n`;
				this.mpfFileName = "";
			}
		},
		loadFile: function (e) {
			let file = e.target.files[0];
			let reader = new FileReader();
			reader.addEventListener("load", () => {
				this.mpfFileName = file.name;
				this.message = reader.result;

				$('.load-active').addClass('active');
			}, false);

			if (file) {
				reader.readAsText(file);
			}
		},
		openChannel: function() {
			if (this.openChannelType) {
				this.openedUuid = null;

				axios.put(this.mainConnectionUrl, {
					action: 'open_channel',
					channel_name: this.openChannelType,
					connection_timeout: this.messageTimeout
				}).then((resp) => {
					this.openChannelType = ""
					let new_uuid = resp.data.result.uuid;

					if (!this.setChannel(new_uuid, this.channels)) {
						// State management problems: we might not have the channel yet.
						// This seems like an argument for handlign the open in the
						// browser. In the event the channel is not fetched yet, we set openedUuid and process later...
						this.openedUuid = new_uuid;
					}

				}).catch(function (error) {
					console.log("Failed to open channel", error)
					alert("Failed to open channel. ");
				});
			}
		},
		doHistory(e, cb) {
			if ((e.target.selectionStart === 0 && e.target.selectionEnd === 0) || e.target.value.indexOf('\n') === -1) {
				e.preventDefault();
				this.message = cb()
				this.$nextTick(() => {
					e.target.selectionStart = 0
					e.target.selectionEnd = 0
				})
			}
		},
		historyUp: function(e) {
			this.doHistory(e, this.history.up)
		},
		historyDown: function(e)  {
			this.doHistory(e, this.history.down)
		},
		sendMessageWithEnter: function() {
			this.sendMessage()
		},
		sendMessage: function () {
			if (this.message !== "") {
				let result = this.handler.process_input(this.message);

				if (result.valid) {
					this.history.push(this.message)
					this.message = ''

					this.$refs.new_message.classList.add('valid')
					this.$refs.new_message.classList.remove('invalid')
					this.input_error = result.msg
				} else {

					this.$refs.new_message.classList.remove('valid')
					this.$refs.new_message.classList.add('invalid')
					this.input_error = result.msg
				}
			}
		},
		inputChanged() {
			this.$refs.new_message.classList.remove('valid')
			this.$refs.new_message.classList.remove('invalid')

			if (this.input_error)
				this.input_error = ''
		},
		setChannel: function (channel_uuid, channels, autoconnect) {
			const findChannel = (find_uuid) => {
				let found = false;
				for (let [idx, channel] of channels.entries()) {
					if (channel.id === find_uuid) {
						found = idx;
						break;
					}
				}
				return found;
			};

			let foundIdx = findChannel(channel_uuid);

			if (foundIdx === false) {
				if (channels.length === 0) {
					this.selectedConnection = null;
				} else if (!this.selectedConnection || findChannel(this.selectedConnection) === false) {
					this.selectedConnection = (autoconnect === true) ? channels[0].id : null;
				}
			} else {
				if (!this.selectedConnection || this.selectedConnection !== channel_uuid)
					this.selectedConnection = channels[foundIdx].id;
			}

			return foundIdx !== false
		},
		initChannelSelect: function() {
			if (this.$refs.channel_select)
				M.FormSelect.init(this.$refs.channel_select)
		},
		messageReceived: function(msg) {
			this.messages.push(msg)
		},
	},
  updated: function() {
		this.initChannelSelect()

		if (this.$refs.message_box) {
			this.$refs.message_box.scrollTop = this.$refs.message_box.scrollHeight;
		}
	},
	mounted: function() {
		this.api.query(ClientConnections, this.server_id, this.client_id).updated((result) => {
			this.channels = result
		})

		if (localStorage.autoconnect !== undefined) {
			this.autoconnect = localStorage.autoconnect === "true"
		}

		this.initChannelSelect();
	},
	beforeDestroy: function() {
		this.connManager.connect(null)
	},
	props: {
		client_id: String,
		server_id: String,
		api: Object,
	}
};
</script>
<template>
	<div>

		<modal-dialog button="Open"
			header="Open Channel" id="open-channel-modal" v-bind:onAccept="openChannel">
				<div class="input-field">
					<select class="browser-default" v-model="openChannelType">
						<option disabled value="">Select channel type</option>
						<option v-for="name in channelTypes" v-bind:key="name" v-bind:value="name">
							{{name}}
						</option>
					</select>
				</div>
		</modal-dialog>

		<div class="section">
			<div class="row">
				<!--	<div v-if="connection === null" class="col s12">
					<h5> Not Connected</h5>
				</div>-->
				<div class="input-field col s12 m8">
					<select ref="channel_select" v-model="selectedConnection" v-bind:class="(connection !== null) ? 'connected' : 'disconnected'">
						<option v-bind:value="null">Not Connected</option>
						<option v-for="channel in channels" v-bind:key="channel.id" v-bind:value="channel.id">
								{{channel.name}}
						</option>
					</select>
					<label>Channel</label>
				</div>
					<div class="input-field col m2 hide-on-small-only switch">
						<label>Off
							<input type="checkbox" v-model="autoconnect">
							<span class="lever"></span>
							Auto
						</label>
					</div>
					<div class="input-field col m1 hide-on-small-only">
						<button :disabled="connection === null" v-on:click="closeChannel(connection)" class="btn waves-effect waves-light red">
							<i class="material-icons">close</i>
						</button>
					</div>
					<div class="input-field col m1 hide-on-small-only">
						<button :disabled="channelTypes === null"
							class="btn waves-effect waves-light green modal-trigger" data-target="open-channel-modal">
							<i class="material-icons">add</i>
						</button>
					</div>
					<p v-if="connection_error" class="col s12 disconnected">{{connection_error}}</p>
				</div>

			<!-- message box row -->
			<div class="row">
				<div class="col s12">
					<div
						class="base2 collection"
						style="min-height: 45vh; max-height: 45vh; overflow-y: scroll; overflow-x: scroll;" ref="message_box">
						<message v-for="(message, index) in messages" v-bind:key="`msg-${index}`"
							v-bind:message="message.message"
							v-bind:title="message.title"
							v-bind:format="message.format"
							v-bind:error="message.error"
							v-bind:raw="message.raw"></message>
					</div>
				</div> <!-- col -->
			</div> <!-- row -->

			<!-- Mesage box buttons -->
			<div class="row hide-on-small-only">
				<div class="col m6">
					<a class="btn blue"
						v-bind:href="'data:text/plain;charset=utf-8,' + streamFileData"
						v-bind:download="streamFileName">Save Stream</a>
				</div>
				<div class="col m6">
					<button v-on:click="clearMessages"
						v-bind:class="'right btn red' + (messages.length ? '' : ' disabled')">
						Clear
					</button>
				</div> <!-- col -->
			</div> <!-- row -->

		</div> <!--section-->

		<div class="divider"></div>

		<div class="section">

			<div class="row">

				<div class="col s12 input-field">
					<label class="load-active" for="new-message">Message</label>
					<textarea ref="new_message" id="new-message" class="materialize-textarea code-font message-input"
						v-model="message" style="white-space: pre;"
						@keypress.enter.exact.prevent="sendMessageWithEnter"
						@keydown.up.exact="historyUp"
						@keydown.down.exact="historyDown"
						@input="inputChanged"
					>
					</textarea>
					<span class="helper-text" :data-error="input_error"></span>
					<button :disabled="connection === null" v-on:click="sendMessage" class="btn waves-effect waves-light">
						Send<i class="material-icons right">send</i>
					</button>
				</div>
			</div> <!-- row -->

			<div class="row">
				<div v-if="supportsProtocol('JSON-RPC')" class="col s4 valign-wrapper">
					<a class="dropdown-trigger btn" data-target="json-rpc-dropdown-content" ref="json-rpc-dropdown">JSON RPC</a>
					<ul id="json-rpc-dropdown-content" class="dropdown-content">
						<li><a v-on:click="populateJsonRpcMethod(`get('appl.name')`)">Get</a></li>
						<li><a v-on:click="populateJsonRpcMethod(`set([{'foo': 'bar'}])`)">Set</a></li>
						<li class="divider" tabindex="-1"></li>
						<li><a v-on:click="populateJsonRpc">Blank</a></li>
					</ul>
				</div>

				<div v-if="supportsProtocol('ZEBRA-JSON')" class="hide-on-small-only">
					<div class="file-field input-field col s4">
						<div class="btn blue">
							<span>Load File</span>
							<input type="file" v-on:change="loadFile($event)">
						</div>
						<div class="file-path-wrapper">
							<input class="file-path validate" type="text">
						</div>
					</div>
					<div class="row col s6">
						<div class="input-field col s8">
							<label class="load-active" for="mpf-name">MPF File Name</label>
							<input id="mpf-name" type="text" class="validate" v-model="mpfFileName">
							<span class="helper-text" data-error="Required" data-success="OK">Name the file</span>
						</div>
						<button class="waves-effect waves-light btn blue col s4" type="button"
							v-on:click="encodeToMpf">Wrap in MPF</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style type="text/css">

.disconnected {
	color: red;
}

@font-face {
  font-family: 'DejaVu Sans Mono';
  src: local('DejaVu Sans Mono'), url('~dejavu-fonts-ttf/ttf/DejaVuSansMono.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.code-font {
  font-family: 'DejaVu Sans Mono', monospace;
}

.base02 {
  background-color: #073642;
}

.base0 {
  color: #839496;
}

.title-success {
	/* solarized base01 slightly bold */
  color: #586e75;
	font-weight: 500 !important;
}

.title-error {
	/* solarized red slightly */
	color: #dc322f;
	font-weight: 500 !important;
}

.base01 {
  color: #586e75;
}

.base2 {
  background-color: #eee8d5;
}

.base3 {
  background-color: #fdf6e3 !important;
}


.message-input {
  background-color: #fdf6e3 !important;
	color: #586e75 !important;
}
</style>
